import * as type from './types'
import actions from './actions'
import api from '../../../api'

const state = {
  myUser: {},
  menuShown: true,
  /** Полностью скрыть сайдбар/mobile-header (напр. map fullscreen) */
  menuChromeHidden: false,
  notifications: null,
  totalNotificationsCount: 0,
  userNotificationSettings: null,
  adminNotificationSettings: null,
  downloadLoading: false
}

const mutations = {
  SET_DOWNLOAD_LOADING(state, payload) {
    state.downloadLoading = payload
  },
  [type.GET_MY_USER](state, payload) {
    state.myUser = payload
  },
  [type.TOGGLE_MENU](state, payload) {
    state.menuShown = payload
  },
  [type.SET_MENU_CHROME_HIDDEN](state, payload) {
    state.menuChromeHidden = Boolean(payload)
  },
  [type.SET_NOTIFICATIONS](state, payload) {
    state.notifications = payload
  },
  [type.SET_USER_NOTIFICATION_SETTINGS](state, payload) {
    state.userNotificationSettings = payload
  },
  [type.SET_ADMIN_NOTIFICATION_SETTINGS](state, payload) {
    state.adminNotificationSettings = payload
  },
  [type.SET_TOTAL_NOTIFICATIONS_COUNT](state, payload) {
    state.totalNotificationsCount = payload
  }
}

const getters = {}

export default {
  state,
  mutations,
  actions,
  getters
}
